let locales = {
    configStatusLeads_status: 'Statto',
    configStatusLeads_description: 'Descrizione dello stato',
};
export default locales;